export default __webpack_public_path__ + "static/media/mysticsuppression.a50f4e9e.png";